import React, { useState } from "react";
import fileUplodIcon from "../../assets/icons/uploadfileicon.png";
import crossIcon from "../../assets/icons/crossicon.png";
import pdfIcon from "../../assets/icons/pdficon.png";
import wordIcon from "../../assets/icons/mswordicon.png";
import { message, Upload } from "antd";
import { Button } from "../Button/Button";
import { useNavigate } from "react-router-dom";
const { Dragger } = Upload;

const checkFileExtension = (file) => {
  return file?.split(".")?.pop()?.toLowerCase();
};
const getTextBeforePdf = (file) => {
  const fileExtension = checkFileExtension(file);
  const extensionIndex = file?.toLowerCase()?.indexOf(`.${fileExtension}`);

  if (extensionIndex !== -1) {
    return file?.slice(0, extensionIndex);
  }
  return null;
};

const ResumeSection = ({ id }) => {
  const [fileList, setFileList] = useState([]);
  const navigate = useNavigate();

  const props = {
    fileList,
    name: "file",
    multiple: false,
    accept: ".docx, .doc, .pdf",
    itemRender: (originNode, file, fileList, action) => {
      return (
        <div
          className="d-flex align-items-center justify-content-lg-between justify-content-center my-4 rounded-3 flex-wrap flex-lg-nowrap gap-4 gap-lg-0"
          style={{ padding: "18px 21px", background: "#0E1620" }}
        >
          <div className="d-flex align-items-center gap-4">
            <img src={fileUplodIcon} alt="" />
            <span className="text-white">
              {file.name.length <= 22
                ? getTextBeforePdf(file.name)
                : `${file.name.slice(0, 19)}...`}
            </span>
          </div>

          <div className="d-flex align-items-center gap-4">
            <img
              src={checkFileExtension(file.name) === "pdf" ? pdfIcon : wordIcon}
              alt=""
            />
            <span className="text-white">
              {checkFileExtension(file.name) === "pdf"
                ? "PDF Document"
                : "Ms Word Document"}
            </span>
          </div>

          <Button
            background="#38444A"
            textColor="white"
            className={"px-3 py-2"}
            onClick={() => {
              action.remove();
            }}
          >
            <div className="d-flex align-items-center gap-3">
              <img src={crossIcon} alt="" />
              <span className="text-white">Remove file</span>
            </div>
          </Button>
        </div>
      );
    },

    beforeUpload(file) {
      const isPDFOrDocx =
        file.type === "application/pdf" ||
        file.type ===
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
        file.type === "application/msword";

      const isValidExtension =
        file.name.endsWith(".pdf") ||
        file.name.endsWith(".docx") ||
        file.name.endsWith(".doc");

      if (!isPDFOrDocx || !isValidExtension) {
        message.error("You can only upload PDF or Ms Word Document");

        return Upload.LIST_IGNORE;
      }

      return true;
    },

    onChange(info) {
      const { status } = info.file;

      if (info.fileList.length > 1) {
        setFileList([info.fileList[info.fileList.length - 1]]);
        return;
      }
      setFileList(info.fileList);

      if (status !== "uploading") {
        console.log(info.file, info.fileList);
      }
      if (status === "done") {
        message.success(`${info.file.name} file uploaded successfully.`);
      } else if (status === "error") {
        // message.error(`${info.file.name} file upload failed.`);
      }
    },
    
    onDrop(e) {
      console.log("Dropped files", e.dataTransfer.files);
    },
  };
  return (
    <>
      <div
        className=" d-flex align-items-center justify-content-center flex-column mt-1 p-5 gap-5 "
        style={{ background: "#131e2c", border: "1px solid #1e2a68" }}
        id={id}
      >
        <h3 className="text-white display-5 align-self-start">
          Attach your resume
        </h3>
        <Dragger
          {...props}
          className="resume-upload"
          style={{ background: "#06091B" }}
        >
          <div className="d-flex flex-column gap-2 p-5 ">
            <p className="ant-upload-text text-white">
              Drop your resume PDF or MS Word file here
            </p>
            <p className="ant-upload-text text-white">OR</p>

            <div className="d-flex align-items-center  justify-content-center ">
              <Button
                background="#0039EC"
                className={"px-4 "}
                textColor="white"
                onClick={(e) => {
                  e.stopPropagation();
                  navigate("/careers");
                }}
              >
                Browse Job
              </Button>
            </div>
          </div>
        </Dragger>
      </div>
    </>
  );
};

export default ResumeSection;
